import { cn } from "@win-reality/react-ui";
import { ReactNode } from "react";

type FeedCardProps = {
  children: ReactNode;
  /** Test id and instance attributes, passed as literals by the call site */
  "data-testid"?: string;
  "data-inning"?: number;
  "data-half"?: "top" | "bottom";
  "aria-expanded"?: boolean;
};

/** Card shell for a half-inning group: rounded top edge, no fill. */
export const FeedCard = ({ children, ...attributes }: FeedCardProps) => (
  <div
    {...attributes}
    className={cn(
      // Border
      "rounded-t-xl border-t border-tagging-sidebar-border",
    )}
  >
    {children}
  </div>
);

export const FeedSectionLabel = ({ children }: { children: ReactNode }) => (
  <h4 className="text-sm uppercase tracking-wide text-tagging-muted">
    {children}
  </h4>
);
